import orderStore from "@/stores/order.store";
import { Autocomplete, Grid, TextField, debounce } from "@mui/material";
import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import "./search.provider.autocomplete.css";

interface ISearchProviderAutocomplete {
    value?: string | null;
    width?: string;
    label?: string | null;
    updateProvider: (arg: string | null) => void;
}

const SearchProviderAutocomplete: FC<ISearchProviderAutocomplete> = (props: ISearchProviderAutocomplete) => {
    const [providerOptions, setProviderOptions] = useState<string[]>([]);
    const { t } = useTranslation();

    const debouncedSearch = debounce(async (value: string) => {
        if (value.length >= 2) {
            await orderStore.searchProviders(value);
            setProviderOptions(orderStore.autocompleteProviders);
        } else if (value.length < 2) {
            setProviderOptions([]);
        }
    }, 400);

    const onChange = (event: React.SyntheticEvent, value: string, reason: string) => {
        debouncedSearch(value);
    };

    return (
        <Grid>
            <Autocomplete
                className="user-combo-box-provider"
                options={providerOptions}
                size="small"
                onInputChange={onChange}
                getOptionLabel={(option) => option}
                isOptionEqualToValue={(option, value) => option === value}
                noOptionsText={t("general.NotFound")}
                value={props.value}
                onChange={(event, newValue) => {
                    if (newValue) {
                        props.updateProvider(newValue);
                    } else {
                        props.updateProvider(null);
                    }
                }}
                sx={{ width: props.width ?? "100%", borderRadius: "6px" }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={props.label ? props.label : t("orders.serviceProvider")}
                        InputProps={{
                            ...params.InputProps,
                            placeholder: `${t("general.MoreCharacters")}`,
                        }}
                    />
                )}
            />
        </Grid>
    );
};

export default SearchProviderAutocomplete;
